// extracted by mini-css-extract-plugin
module.exports = {"container":"_d5a2acf","header":"_45b082b","headerTitle":"_727fd49","clearResults":"_5308663","results":"_c0db77c","resultContainer":"_7187d4f","result":"_d47fc34"};